import ArtistArtworkRecords from "./ArtistArtworkRecords";
export default ArtistArtworkRecords;
